import moment from 'moment';
import { action } from 'typesafe-actions';
import { Types, IFabricationOrder, IDownloadNFEResponse } from './types';

export const loadFabricationOrders = (
  selectedContractNumbers: string[],
  startDate: moment.Moment,
  endDate: moment.Moment,
  needToLoadContract?: boolean
) =>
  action(Types.LOAD_FABRICATION_ORDERS, {
    selectedContractNumbers,
    startDate,
    endDate,
    needToLoadContract
  });
export const loadFabricationOrdersSuccess = (
  fabricationOrders: IFabricationOrder[]
) => action(Types.LOAD_FABRICATION_ORDERS_SUCCESS, { fabricationOrders });
export const loadFabricationOrdersFailure = (
  error: unknown,
  contractError?: boolean
) => action(Types.LOAD_FABRICATION_ORDERS_FAILURE, { error, contractError });

export const loadNFFileFromFabricationOrderDelivery = (
  fabricationOrderId: number,
  deliveryId: number,
  danfeNumber: string
) =>
  action(Types.LOAD_NF_FILE_FROM_FABRICATION_ORDERS, {
    fabricationOrderId,
    deliveryId,
    danfeNumber
  });
export const loadNFFileFromFabricationOrderDeliverySuccess = (
  fabricationOrderId: number,
  deliveryId: number,
  downloadNFEResponse: IDownloadNFEResponse
) =>
  action(Types.LOAD_NF_FILE_FROM_FABRICATION_ORDERS_SUCCESS, {
    fabricationOrderId,
    deliveryId,
    downloadNFEResponse
  });
export const loadNFFileFromFabricationOrderDeliveryFailure = (
  fabricationOrderId: number,
  deliveryId: number,
  error: unknown
) =>
  action(Types.LOAD_NF_FILE_FROM_FABRICATION_ORDERS_FAILURE, {
    fabricationOrderId,
    deliveryId,
    error
  });
export const downloadNFFile = (
  fabricationOrderId: number,
  deliveryId: number,
  downloadNFEResponse: IDownloadNFEResponse
) =>
  action(Types.DOWNLOAD_NF_FILE_FROM_FABRICATION_ORDERS, {
    fabricationOrderId,
    deliveryId,
    downloadNFEResponse
  });

export const clearFabricationOrdersState = () =>
  action(Types.CLEAR_FABRICATION_ORDERS_STATE);

export const loadFabricationOrderByIdSaga = (orderId: number) =>
  action(Types.LOAD_FABRICATION_ORDERS_BY_ID, {
    orderId
  });

export const loadFabricationOrderByIdSagaSuccess = (
  selectedOrder: IFabricationOrder
) =>
  action(Types.LOAD_FABRICATION_ORDERS_BY_ID_SUCCESS, {
    selectedOrder
  });
export const loadFabricationOrderByIdSagaFailure = (
  orderId: number,
  error: unknown
) =>
  action(Types.LOAD_FABRICATION_ORDERS_BY_ID_FAILURE, {
    orderId,
    error
  });
